import { render, staticRenderFns } from "./warehouse-store.vue?vue&type=template&id=9c4cff84&scoped=true"
import script from "./warehouse-store.vue?vue&type=script&lang=js"
export * from "./warehouse-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4cff84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c4cff84')) {
      api.createRecord('9c4cff84', component.options)
    } else {
      api.reload('9c4cff84', component.options)
    }
    module.hot.accept("./warehouse-store.vue?vue&type=template&id=9c4cff84&scoped=true", function () {
      api.rerender('9c4cff84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/warehouse-management/warehouse-store/warehouse-store.vue"
export default component.exports